import axios, { AxiosResponse } from 'axios';
import { action, makeObservable } from 'mobx';
import { RootStore } from '../rootStore';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type RequestFunctionType = (params: any) => Promise<AxiosResponse<any>>;

export class RequestProcessor {
  // State
  private readonly rootStore: RootStore;

  public async processRequest<Res, ReqParams = Record<string, never>>(
    requestFunc: RequestFunctionType,
    params: ReqParams,
  ): Promise<AxiosResponse<Res> | null> {
    try {
      const res = await requestFunc(params);
      return res.status >= 200 && res.status <= 300 ? res : null;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        switch (error.response?.status) {
          case 500:
            this.rootStore.notificationStore.setNotification({
              type: 'error',
              title: 'Server error',
              msg: 'Something went wrong on the server, please contact support or try again later.',
            });
            break;
          case 400:
            this.rootStore.notificationStore.setNotification({
              type: 'error',
              title: 'Server error',
              msg: 'Something went wrong on the server, please contact support or try again later.',
            });
            break;
          case 401:
          case 403:
            this.rootStore.notificationStore.setNotification({
              type: 'error',
              title: 'Authorization error',
              msg: 'Your session has expired. Re-login please.',
            });
            this.rootStore.loginSessionStore.logOutUser();
            break;
          default:
            this.rootStore.notificationStore.setNotification({
              type: 'error',
              title: 'Unknown error!',
              // eslint-disable-next-line
              msg: error.response?.data.errors.map((el: { message: any }) => el.message).join(', '),
            });
        }
      } else {
        throw new Error('Unknown error occurred!');
      }
      return null;
    }
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      processRequest: action.bound,
    });
  }
}
